import React from 'react';
import {useStyles} from "./MoneySalePrices.style";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useI18nContext } from '../../../../contexts/I18nContext';
import { Observer } from 'mobx-react-lite';
import MoneySalePriceRow from './MoneySalePricesRow/MoneySalePriceRow';
import MessageCard from '../../../../ui_components/MessageCard/MessageCard';
import MoneySalePricesProperties from './MoneySalePricesProperties';
import ButtonSize from '../../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../../ui_components/Button/ButtonType';
import NewMoneySalePriceButton from '../../../../shared_components/Buttons/NewMoneySalePriceButton/NewMoneySalePriceButton';
import CopyServicePricesButton from '../../../../shared_components/Buttons/CopyServicePricesButton/CopyServicePricesButton';
import SalePriceItemType from '../../../../entities/SalePriceItemType';


const MoneySalePrices: React.FC<MoneySalePricesProperties> = ({
    salePrice,
    onUpdate = () => {
    },
}) => {
    const i18n = useI18nContext();
    const classes = useStyles();

    return (
        <Observer>
            {() => (
                <div className={classes.money_sale_prices_container}>
                    <div className={classes.new_button_container}>
                        <CopyServicePricesButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            sourceSalePriceId={salePrice?.id ?? ''}
                            serviceName={SalePriceItemType.MONEY}
                            type={ButtonType.SECONDARY}
                        />
                        <NewMoneySalePriceButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            salePriceId={salePrice?.id ?? ''}
                            type={ButtonType.SECONDARY}
                        />
                    </div>
                    {salePrice?.moneySalePrices != null && salePrice?.moneySalePrices.length > 0 &&
                    <div className={classes.money_sale_prices_table}>
                        <div className={classes.elements_container}>
                            {salePrice?.moneySalePrices
                                ?.slice()
                                .sort((a, b) => a.fromValue - b.fromValue)
                                .map((moneySalePrice, i) => (
                                    <MoneySalePriceRow
                                        onUpdate={onUpdate}
                                        moneySalePrice={moneySalePrice}
                                        salePrice={salePrice}
                                        key={i}
                                    />
                            ))}
                        </div>
                    </div>}
                    {(salePrice?.moneySalePrices == null || salePrice?.moneySalePrices.length === 0 ) &&
                    <MessageCard icon={CurrencyExchangeIcon} title={i18n.translate("NO_MONEY_SERVICE_FEE_TITLE")}
                                 subtitle={i18n.translate("NO_MONEY_SERVICE_FEE_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default MoneySalePrices;
